.root {
  opacity: 0;
  transition: 0.6s ease;
  pointer-events: none;
}

.root--is-visible {
  opacity: 1;
}
